'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { ROUTES, SUB_DOMAIN } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useIsNewUser } from '@/hooks/useIsNewUser';
import { useDeviceInfoStore } from '@/stores/DeviceStore';

/** 허용된 경로 */
const ALLOWED_PATHS = ['/join', '/kb-join', '/login', '/easy-certification'];
export const JoinController = () => {
  const $ = _c(9);
  const isNewUser = useIsNewUser();
  const isKbPay = useDeviceInfoStore(_temp);
  const pathname = usePathname();
  const router = useCustomRouter();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname ? ALLOWED_PATHS.some(path => pathname.startsWith(path)) : true;
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isAllowedPath = t0;
  let t1;
  let t2;
  if ($[2] !== isAllowedPath || $[3] !== isKbPay || $[4] !== isNewUser || $[5] !== router) {
    t1 = () => {
      if (isAllowedPath || !isNewUser) {
        return;
      }
      if (isKbPay) {
        router.replace(ROUTES.KB_JOIN_COMMON.withSearchParams({
          searchParams: {
            step: 1
          }
        }));
      } else {
        router.replace(ROUTES.JOIN_COMMON.withSearchParams({
          searchParams: {
            step: 1
          }
        }));
      }
    };
    t2 = [isNewUser, isAllowedPath, isKbPay, router];
    $[2] = isAllowedPath;
    $[3] = isKbPay;
    $[4] = isNewUser;
    $[5] = router;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <></>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
function _temp(state) {
  return state.subDomain === SUB_DOMAIN.KB_PAY;
}